import script from "./biz2pro.vue?vue&type=script&lang=js"
export * from "./biz2pro.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__